<template>
<div class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Status</span>
                <span class="default-settings-subtitle">Filter snapshots by their status</span>
            </div>

            <div class="backup" style="margin-top: 20px !important;">
                <div class="columns is-multiline">
                    <div @click="toggleStatus(status)" v-for="status in statuses.data" class="column" :class="{ 'is-one-fifth': hasFiveStatuses, 'is-2': !hasFiveStatuses }">
                        <div :class="{'backup-frequency-selected': statusIsSelected(status) != -1 }" class="backup-frequency backup-frequency-selectable" style="text-align:center; padding: 0 !important; height:40px !important">
                            <div class="details" style="margin-top:9px !important;">
                                <div class="detail-value">{{ status.name }}</div>
                            </diV>
                        </div>
                    </div>
                </div>
            </div>
            <div class="default-settings-title" style="margin-top: 40px !important;">
                <span class="account-name">Tags</span>
                <span class="default-settings-subtitle">Filter snapshots by tags</span>
            </div>

            <div class="backup" style="margin-top: 20px !important;">
                <div class="columns is-multiline">
                    <div @click="toggleTag(tag)" v-for="tag in tags.data" class="column is-2">
                        <div :class="{'backup-frequency-selected': tagIsSelected(tag) != -1 }" class="backup-frequency backup-frequency-selectable" style="text-align:center; padding: 0 !important; height:40px !important">
                            <div class="details" style="margin-top:9px !important;">
                                <div class="detail-value">{{ tag.name }}</div>
                            </diV>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" style="margin-top: 40px !important;">
                <div class="column is-3">
                    <div @click="applyFilters" class="button custom-button-size is-fullwidth is-info">Apply filters</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger">Cancel</div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';

export default {
    data() {
        return {
            active: false,
            tags: [],
            statuses: [],
            selectedStatuses: [],
            selectedTags: [],
            loadingTags: false,
            loadingStatuses: false,
            initialTagsLoaded: false,
            initialStatusesLoaded: false,
        }
    },

    mounted() {
        this.getTags();
        this.getStatuses();
        this.listenEvents();
    },

    methods: {
        getTags() {
            let endpoint = 'tags';

            Api().get(endpoint)
                .then((response) => {
                    this.tags = response.data;
                    this.selectAllTags();
                    this.initialTagsLoaded = true;
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingTags = false;
                });
        },

        getStatuses() {
            let endpoint = 'snapshots/statuses';

            Api().get(endpoint)
                .then((response) => {
                    this.statuses = response.data;
                    this.selectedStatuses.push('completed');
                    this.selectedStatuses.push('in_progress');
                    this.selectedStatuses.push('errored');
                    this.initialStatusesLoaded = true;
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingStatuses = false;
                });
        },

        selectAllTags() {
            for (var i = 0; i < this.tags.data.length; i++) {
                this.selectedTags.push(this.tags.data[i].id);
            }
        },

        show() {
            this.active = true;
        },

        close() {
            this.active = false;
        },

        listenEvents() {
            Event.$on('showSnapshotsFilters', () => {
                this.show();
            });
        },

        statusIsSelected(status) {
            for (var i = 0; i < this.selectedStatuses.length; i++) {
                if (this.selectedStatuses[i] == status.slug) {
                    return i;
                }
            }
            return -1;
        },

        toggleStatus(status) {
            var index = this.statusIsSelected(status);
            // Not selected, select it
            if (index == -1) {
                this.selectedStatuses.push(status.slug);
            } else {
                this.selectedStatuses.splice(index, 1);
            }
        },

        tagIsSelected(tag) {
            for (var i = 0; i < this.selectedTags.length; i++) {
                if (this.selectedTags[i] == tag.id) {
                    return i;
                }
            }
            return -1;
        },

        toggleTag(tag) {
            var index = this.tagIsSelected(tag);
            // Not selected, select it
            if (index == -1) {
                this.selectedTags.push(tag.id);
            } else {
                this.selectedTags.splice(index, 1);
            }
        },

        applyFilters() {
            Event.$emit('snapshotsFiltersUpdated', this.selectedTags, this.selectedStatuses);
            this.close();
        },
    },

    computed: {
        hasFiveStatuses() {
            return typeof this.statuses.data !== 'undefined' && this.statuses.data.length == 5;
        },
    },

    watch: {
        initialTagsLoaded(loaded) {
            if (loaded && this.initialStatusesLoaded) {
                this.applyFilters();
            }
        },

        initialStatusesLoaded(loaded) {
            if (loaded && this.initialTagsLoaded) {
                this.applyFilters();
            }
        },
    },
}
</script>
